import { useEffect } from 'react';
import { useGlobalModalContext } from '../../components/GlobalModal';

const useModalErrorHandler = (setIsLoading: (isSaving: boolean) => void): void => {
  const { store } = useGlobalModalContext();

  useEffect(() => {
    if (store.props?.error) {
      setIsLoading(false);
    }
  }, [store.props?.error]);
};

export default useModalErrorHandler;
